import { render, staticRenderFns } from "./OTDRAgreement.vue?vue&type=template&id=159945bc&scoped=true&"
import script from "./OTDRAgreement.vue?vue&type=script&lang=js&"
export * from "./OTDRAgreement.vue?vue&type=script&lang=js&"
import style0 from "./OTDRAgreement.vue?vue&type=style&index=0&id=159945bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159945bc",
  null
  
)

export default component.exports